export default {
  team: [
    {
      role: "Режисер-постановщик",
      members: ["Терян Евгения"]
    },
    {
      role: "Авторы сценария",
      members: [
        "Амбарцумова Амбарцумова",
        "Бойко Бойко",
        "Аветунци Аветунци",
        "Паноян Паноян",
        "Багдасарян Багдасарян",
        "Саргсян Саргсян",
        "Закарян Закарян",
        "Аллавердян Аллавердян",
        "Терян Терян",
        "Варданян Варданян",
        "Зограбян Зограбян",
        "Бойко Бойко",
        "Аракелян Аракелян",
        "Дзядко Дзядко"
      ]
    },
    {
      role: "Продюссеры",
      members: [
        "Аветунци Гагик",
        "Паноян Джемма",
        "Саргсян Лиана",
        "Багдасарян Анна",
        "Багдасарян Кристина",
        "Мнацаканян Арина",
        "Чахоян Ирина",
        "Адамян Лусине",
        "Айриян Седа",
        "Шермазанов Давид",
        "ФАМИЛИЯ Эмилия",
        "Аракелян Лия",
        "Терян Ольга",
        "Бойко Иван",
        "Варданян Наринэ",
        "Аллавердян Анна",
        "Закарян Анна",
        "Кочарян Гаяне"
      ]
    },
    {
      role: " Кастинг (организаторы волонтеров)",
      members: ["Амбарцумова Алина", "Аракелян Лия", "Паноян Джемма"]
    },
    {
      role: "Каскадеры (сами волонтеры)",
      members: []
    },
    {
      role: "Композиторы (вечерняя программа)",
      members: [
        "Бойко Иван",
        "Аллавердян Анна",
        "Багдасарян Анна",
        "Багдасарян Кристина",
        "Варданян Наринэ"
      ]
    },
    {
      role: "Художники декораций (Интерьер+Отель)",
      members: [
        "Фролова Анна",
        "Кочарян Гаяне",
        "Зограбян Татевик",
        "Восканян Аревик",
        "Айриян Седа",
        "Амбарцумова Алина",
        "Аракелян Лия",
        "Аракелян Рузанна"
      ]
    },
    {
      role: "Художники по костюмам (склад+логистика)",
      members: ["Бойко Иван"]
    },
    {
      role: "Монтаж (сайт)",
      members: ["Инанц Гайк", "Аракелян Лия", "Аветунци Гагик"]
    },
    {
      role: "Редакторы (книга)",
      members: []
    },
    {
      role: "Юристы",
      members: ["Саргсян Лиана", "Бойко Иван", "Ельчян Анна"]
    },
    {
      role: "Краудфандинг",
      members: ["Ельчян Анна", "Дзядко Тимофей"]
    }
  ],
  volunteers: [
    {
      id: 1,
      name: "Гагик Аветунци",
      img: "v0.png",
      timeline: [
        {
          year: 2015,
          role: "Волонтер конференции"
        },
        {
          year: 2016,
          role: "Волонтер конференции"
        },
        {
          year: 2017,
          role: "Волонтер конференции Проектная группа PR/ Миссия"
        }
      ],
      description: [
        {
          question: "Аня, как ты попала в Лсаран?",
          ask:
            "У меня полная уверенность, что проект Лсаран я сознательно притянула в свою жизнь. В определенный момент я остро ощутила нехватку в своей жизни Армении. Как сейчас помню: открыла блокнот и на последней странице обозначила конкретное желание быть втянутой в армянскую тусовку."
        },
        {
          question: "И, что вы думаете?",
          ask:
            "Да, видимо, я неплохо улавливаю информацию из ноосферы (улыбается). На фейсбуке увидела комментарий о Лсаране, написала Евгении Терян и мы встретились. Я всегда ориентируюсь на капитанов судна. Уже после первых минут общения с Евгенией, была уверена: мне нужно плыть именно на этом корабле. И с тех пор все свои желания я пишу только в том самом волшебном блокноте."
        },
        {
          question: "Чем ты занимаешься в рамках Лсарана?",
          ask:
            "Я в программной команде. Именно мы изучаем и составляем список лекторов, которые проходят самый жесткий отбор. Приоритеты экспертам расставляем путем голосования. Все честно, каждый член команды презентует своего лектора, отстаивает тему и только потом принимается решение."
        },
        {
          question: "Аня, как ты попала в Лсаран?",
          ask:
            "У меня полная уверенность, что проект Лсаран я сознательно притянула в свою жизнь. В определенный момент я остро ощутила нехватку в своей жизни Армении. Как сейчас помню: открыла блокнот и на последней странице обозначила конкретное желание быть втянутой в армянскую тусовку."
        },
        {
          question: "И, что вы думаете?",
          ask:
            "Да, видимо, я неплохо улавливаю информацию из ноосферы (улыбается). На фейсбуке увидела комментарий о Лсаране, написала Евгении Терян и мы встретились. Я всегда ориентируюсь на капитанов судна. Уже после первых минут общения с Евгенией, была уверена: мне нужно плыть именно на этом корабле. И с тех пор все свои желания я пишу только в том самом волшебном блокноте."
        },
        {
          question: "Чем ты занимаешься в рамках Лсарана?",
          ask:
            "Я в программной команде. Именно мы изучаем и составляем список лекторов, которые проходят самый жесткий отбор. Приоритеты экспертам расставляем путем голосования. Все честно, каждый член команды презентует своего лектора, отстаивает тему и только потом принимается решение."
        }
      ]
    },
    {
      id: 2,
      name: "Лусине Адамян",
      img: "v1.png",
      timeline: [
        {
          year: 2015,
          role: "Волонтер конференции"
        },
        {
          year: 2016,
          role: "Волонтер конференции"
        },
        {
          year: 2017,
          role: "Волонтер конференции Проектная группа PR/ Миссия"
        }
      ],
      description: [
        {
          question: "Аня, как ты попала в Лсаран?",
          ask:
            "У меня полная уверенность, что проект Лсаран я сознательно притянула в свою жизнь. В определенный момент я остро ощутила нехватку в своей жизни Армении. Как сейчас помню: открыла блокнот и на последней странице обозначила конкретное желание быть втянутой в армянскую тусовку."
        },
        {
          question: "И, что вы думаете?",
          ask:
            "Да, видимо, я неплохо улавливаю информацию из ноосферы (улыбается). На фейсбуке увидела комментарий о Лсаране, написала Евгении Терян и мы встретились. Я всегда ориентируюсь на капитанов судна. Уже после первых минут общения с Евгенией, была уверена: мне нужно плыть именно на этом корабле. И с тех пор все свои желания я пишу только в том самом волшебном блокноте."
        },
        {
          question: "Чем ты занимаешься в рамках Лсарана?",
          ask:
            "Я в программной команде. Именно мы изучаем и составляем список лекторов, которые проходят самый жесткий отбор. Приоритеты экспертам расставляем путем голосования. Все честно, каждый член команды презентует своего лектора, отстаивает тему и только потом принимается решение."
        },
        {
          question: "Аня, как ты попала в Лсаран?",
          ask:
            "У меня полная уверенность, что проект Лсаран я сознательно притянула в свою жизнь. В определенный момент я остро ощутила нехватку в своей жизни Армении. Как сейчас помню: открыла блокнот и на последней странице обозначила конкретное желание быть втянутой в армянскую тусовку."
        },
        {
          question: "И, что вы думаете?",
          ask:
            "Да, видимо, я неплохо улавливаю информацию из ноосферы (улыбается). На фейсбуке увидела комментарий о Лсаране, написала Евгении Терян и мы встретились. Я всегда ориентируюсь на капитанов судна. Уже после первых минут общения с Евгенией, была уверена: мне нужно плыть именно на этом корабле. И с тех пор все свои желания я пишу только в том самом волшебном блокноте."
        },
        {
          question: "Чем ты занимаешься в рамках Лсарана?",
          ask:
            "Я в программной команде. Именно мы изучаем и составляем список лекторов, которые проходят самый жесткий отбор. Приоритеты экспертам расставляем путем голосования. Все честно, каждый член команды презентует своего лектора, отстаивает тему и только потом принимается решение."
        }
      ]
    },
    {
      id: 3,
      name: "Лусине Адамян",
      img: "v2.png",
      timeline: [
        {
          year: 2015,
          role: "Волонтер конференции"
        },
        {
          year: 2016,
          role: "Волонтер конференции"
        },
        {
          year: 2017,
          role: "Волонтер конференции Проектная группа PR/ Миссия"
        }
      ],
      description: [
        {
          question: "Аня, как ты попала в Лсаран?",
          ask:
            "У меня полная уверенность, что проект Лсаран я сознательно притянула в свою жизнь. В определенный момент я остро ощутила нехватку в своей жизни Армении. Как сейчас помню: открыла блокнот и на последней странице обозначила конкретное желание быть втянутой в армянскую тусовку."
        },
        {
          question: "И, что вы думаете?",
          ask:
            "Да, видимо, я неплохо улавливаю информацию из ноосферы (улыбается). На фейсбуке увидела комментарий о Лсаране, написала Евгении Терян и мы встретились. Я всегда ориентируюсь на капитанов судна. Уже после первых минут общения с Евгенией, была уверена: мне нужно плыть именно на этом корабле. И с тех пор все свои желания я пишу только в том самом волшебном блокноте."
        },
        {
          question: "Чем ты занимаешься в рамках Лсарана?",
          ask:
            "Я в программной команде. Именно мы изучаем и составляем список лекторов, которые проходят самый жесткий отбор. Приоритеты экспертам расставляем путем голосования. Все честно, каждый член команды презентует своего лектора, отстаивает тему и только потом принимается решение."
        },
        {
          question: "Аня, как ты попала в Лсаран?",
          ask:
            "У меня полная уверенность, что проект Лсаран я сознательно притянула в свою жизнь. В определенный момент я остро ощутила нехватку в своей жизни Армении. Как сейчас помню: открыла блокнот и на последней странице обозначила конкретное желание быть втянутой в армянскую тусовку."
        },
        {
          question: "И, что вы думаете?",
          ask:
            "Да, видимо, я неплохо улавливаю информацию из ноосферы (улыбается). На фейсбуке увидела комментарий о Лсаране, написала Евгении Терян и мы встретились. Я всегда ориентируюсь на капитанов судна. Уже после первых минут общения с Евгенией, была уверена: мне нужно плыть именно на этом корабле. И с тех пор все свои желания я пишу только в том самом волшебном блокноте."
        },
        {
          question: "Чем ты занимаешься в рамках Лсарана?",
          ask:
            "Я в программной команде. Именно мы изучаем и составляем список лекторов, которые проходят самый жесткий отбор. Приоритеты экспертам расставляем путем голосования. Все честно, каждый член команды презентует своего лектора, отстаивает тему и только потом принимается решение."
        }
      ]
    },
    {
      id: "4",
      name: "Нелли Ефремян",
      img: "v3.png",
      timeline: [
        {
          year: 2015,
          role: "Волонтер конференции"
        },
        {
          year: 2016,
          role: "Волонтер конференции"
        },
        {
          year: 2017,
          role: "Волонтер конференции Проектная группа PR/ Миссия"
        }
      ],
      description: [
        {
          question: "Аня, как ты попала в Лсаран?",
          ask:
            "У меня полная уверенность, что проект Лсаран я сознательно притянула в свою жизнь. В определенный момент я остро ощутила нехватку в своей жизни Армении. Как сейчас помню: открыла блокнот и на последней странице обозначила конкретное желание быть втянутой в армянскую тусовку."
        },
        {
          question: "И, что вы думаете?",
          ask:
            "Да, видимо, я неплохо улавливаю информацию из ноосферы (улыбается). На фейсбуке увидела комментарий о Лсаране, написала Евгении Терян и мы встретились. Я всегда ориентируюсь на капитанов судна. Уже после первых минут общения с Евгенией, была уверена: мне нужно плыть именно на этом корабле. И с тех пор все свои желания я пишу только в том самом волшебном блокноте."
        },
        {
          question: "Чем ты занимаешься в рамках Лсарана?",
          ask:
            "Я в программной команде. Именно мы изучаем и составляем список лекторов, которые проходят самый жесткий отбор. Приоритеты экспертам расставляем путем голосования. Все честно, каждый член команды презентует своего лектора, отстаивает тему и только потом принимается решение."
        },
        {
          question: "Аня, как ты попала в Лсаран?",
          ask:
            "У меня полная уверенность, что проект Лсаран я сознательно притянула в свою жизнь. В определенный момент я остро ощутила нехватку в своей жизни Армении. Как сейчас помню: открыла блокнот и на последней странице обозначила конкретное желание быть втянутой в армянскую тусовку."
        },
        {
          question: "И, что вы думаете?",
          ask:
            "Да, видимо, я неплохо улавливаю информацию из ноосферы (улыбается). На фейсбуке увидела комментарий о Лсаране, написала Евгении Терян и мы встретились. Я всегда ориентируюсь на капитанов судна. Уже после первых минут общения с Евгенией, была уверена: мне нужно плыть именно на этом корабле. И с тех пор все свои желания я пишу только в том самом волшебном блокноте."
        },
        {
          question: "Чем ты занимаешься в рамках Лсарана?",
          ask:
            "Я в программной команде. Именно мы изучаем и составляем список лекторов, которые проходят самый жесткий отбор. Приоритеты экспертам расставляем путем голосования. Все честно, каждый член команды презентует своего лектора, отстаивает тему и только потом принимается решение."
        }
      ]
    }
  ]
};
